export default __webpack_public_path__ + "static/media/Edit.385e7a94.svg";